// extracted by mini-css-extract-plugin
module.exports = {"main":"Call_main__3R2OL"};